import axios from 'axios';
import { getApiUrl } from '../../../config';

export const searchBillingEntities = (query, billingOnly, includeNonEntities) => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/entities/search`,
        params: { q: query, billingOnly: billingOnly ? 'true' : 'false', includeNonEntities: includeNonEntities ? 'true' : 'false' },
        withCredentials: true,
        crossorigin: true
    });
};

export const toggleBillingEntity = (entityType, entityId, billingEntity) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/entities/${entityType}/${entityId}/billing-entity`,
        data: { billingEntity },
        withCredentials: true,
        crossorigin: true
    });
};
